<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryThreeCourseInfo">
    <v-flex md2>
      <v-select
        :label="labels.institution"
        v-model="select_school"
        :items="schools"
        item-text="school_name"
        item-value="school_no"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.instructor"
        v-model="course_teacher"
      ></v-text-field>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.eng_program"
        v-model="select_course_notes"
        value="eng"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.general_course"
        v-model="only_general"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.graduate_program"
        v-model="only_master"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.under_graduate_program"
        v-model="only_under_graduate"
      ></v-checkbox>
    </v-flex>
    <v-flex md1>
      <v-btn round :disabled="btn_state" v-on:click="queryThreeCourseInfo()">
        <v-icon>search</v-icon>
        {{ labels.search }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import languages from "../../languages/TabThreeCourse.json";

export default {
  data: () => ({
    labels: {
      institution: "",
      course_title: "",
      instructor: "",
      eng_program: "",
      general_course: "",
      graduate_program: "",
      under_graduate_program: "",
      search: "",
    },
    select_school: "3",
    schools: [],
    course_name: "",
    select_course_notes: [],
    course_teacher: "",
    only_master: "",
    only_under_graduate: "",
    only_general: "",
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    queryThreeCourseInfo: function () {
      var query_params = {
        Semester: this.$store.state.select_semester,
        CourseNo: this.select_school,
        CourseName: this.course_name,
        CourseTeacher: this.course_teacher,
        Dimension: "",
        CourseNotes: this.select_course_notes,
        ForeignLanguage: 0,
        OnlyGeneral: this.only_general * 1,
        OnleyNTUST: 0,
        OnlyMaster: this.only_master * 1,
        OnlyUnderGraduate: this.only_under_graduate * 1,
        OnlyNode: this.$store.state.only_node * 1,
        Language: this.select_language.lang,
      };
      this.$store.dispatch("queryCourseInfo", query_params);
    },
    setLanguage: function (select_language) {
      this.labels.institution = languages.institution[select_language.lang];
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.instructor = languages.instructor[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
      this.labels.eng_program = languages.eng_program[select_language.lang];
      this.labels.general_course =
        languages.general_course[select_language.lang];
      this.labels.graduate_program =
        languages.graduate_program[select_language.lang];
      this.labels.under_graduate_program =
        languages.under_graduate_program[select_language.lang];

      this.schools = [
        {
          school_name: languages.ntu_ntnu[select_language.lang],
          school_no: "3",
        },
        { school_name: languages.ntu[select_language.lang], school_no: "3T" },
        { school_name: languages.ntnu[select_language.lang], school_no: "3N" },
      ];
    },
  },
};
</script>
